import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { useSnackbar } from 'notistack';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Grid, Button, TextField, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, CircularProgress, Chip } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { Edit as EditIcon, DeleteOutline as DeleteOutlineIcon } from '@material-ui/icons';
import AddIcon from '@material-ui/icons/Add';
import { AssetInfo } from '../components'
import { TechSpecsNav } from "../../elements";
import { checkApiStatus } from "../../utils_v2";
import { DeletePopUp, EmptyCollection, PageLoader, Pagination, STableLoader } from "../../shared_elements";
import { globalDeleteService, globalExportService, globalGetService, globalPostService, globalPutService } from "../../../globalServices";
import useAssetInfo from '../hooks/useAssetInfo';
import { assetTypeValues, backendDateFormat, displayDateFormatShort, fieldDateFormat } from "../../../constants";
import { downloadFileType } from "../../../utils";
import { trackActivity } from "../../../utils/mixpanel";
import { usePageTitleOffset } from '../../elements/CollapsibleSideNav';

const QECHD = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell>Description</TableCell>
                <TableCell>Part number</TableCell>
                <TableCell>Serial number</TableCell>
                <TableCell>Date LSV</TableCell>
                <TableCell>Remarks</TableCell>
                <TableCell align="right">Action(s)</TableCell>
            </TableRow>
        </TableHead>
    )
}

const QECListing = ({ item, onEdit, onDelete, onView, assetInfoData }) => {
    const [showMore, setShowMore] = useState({});
    const toggleDescription = (field) => {
        setShowMore({
            ...showMore,
            [field]: !showMore[field]
        })
    }
    return (
        <TableRow>
            <TableCell onClick={(e) => e.stopPropagation()}>
                {item?.description && item?.description?.length > 30 ? (
                    <div  >
                        {showMore[item?.field] && showMore[item?.field] ? (
                            <span> {item?.description}
                                <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  >  less </a>
                            </span>
                        ) : (
                            <span> {item.description.substring(0, 25)}
                                <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  > ..more </a>
                            </span>
                        )}
                    </div>
                ) :
                    <div>{item?.description || '--'}</div>
                }
            </TableCell>
            <TableCell><div style={{ width: "150px" }}>{item?.part_number || '--'}</div></TableCell>
            <TableCell><div style={{ width: "150px" }}>{item?.serial_number || '--'}</div></TableCell>
            <TableCell><div style={{ width: "150px" }}>{moment(item?.date_lsv).isValid() ? moment(item?.date_lsv).format(displayDateFormatShort) : '--'}</div></TableCell>
            <TableCell onClick={(e) => e.stopPropagation()}>
                {item?.remarks && item?.remarks?.length > 30 ? (
                    <div>
                        {showMore[item?.field] ? (
                            <span>
                                <span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.replace(/\n/g, '<br />') }} />
                                <a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}less </a>
                            </span>
                        ) : (
                            <span>
                                <span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.substring(0, 25).replace(/\n/g, '<br />'), }} />
                                <a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}..more </a>
                            </span>
                        )}
                    </div>
                ) : (
                    <div dangerouslySetInnerHTML={{ __html: item?.remarks || '--', }} />
                )}
            </TableCell>
            <TableCell align="right">{
                <ul className="list-inline" style={{ width: '50px', float: 'right' }}>
                        <li className="list-inline-item hover-inline" onClick={onEdit}>
                            <Tooltip title='Edit' arrow><EditIcon color="primary" fontSize="small" /></Tooltip>
                        </li> 
                        <li className="list-inline-item hover-inline" onClick={onDelete}>
                            <Tooltip title='Delete' arrow><DeleteOutlineIcon color="secondary" fontSize="small" /></Tooltip>
                        </li> 
                </ul>}</TableCell>
        </TableRow>
    )
}
const AddQEC = ({ addEditQEC, toggleModalFn, getResponseBack, params, getListApi }) => {
    const [qec, setQec] = useState(addEditQEC?.data?.id ? addEditQEC?.data : {})
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({})
    const { enqueueSnackbar } = useSnackbar();
    const onAddEditSubModule = () => {
        let validateInput = {}
        validateInput = {
            // serial_number: qec?.serial_number?.trim()?.length ? '' : 'Please enter Serial number',
            date_lsv: qec?.date_lsv ? moment(qec?.date_lsv).isValid() ? '' : 'Please enter Valid Date LSV':'',
        }
        if (Object.keys(validateInput).every(k => validateInput[k] === '')) {
            setLoading(true)
            if (qec.id) {
                globalPutService(`console/v2/${params.type}/${params.aircraft_slug}/qec/${qec.id}/`, qec)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                            getResponseBack();
                        }
                    })
            } else {
                globalPostService(`console/v2/${params.type}/${params.aircraft_slug}/qec/`, qec)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                            getResponseBack();
                        }
                    })
            }
        }
        else {
            setError(validateInput)
        }
    }

    const onFieldChange = (key, value) => { setQec({ ...qec, [key]: value }) }
   const isAnyFieldFilled = ['description','part_number','serial_number','date_lsv','remarks'].some(key => qec?.[key]?.toString().trim());
    return (
        <>
            <Dialog
                open={addEditQEC.modal}
                onClose={toggleModalFn}
                className='console-management-modal'
                maxWidth="md"
            >
                <DialogTitle id="scroll-dialog-title">
                    {qec?.id ? 'Edit ' : 'Add '} QEC Data
                </DialogTitle>
                <DialogContent dividers={true}>
                    <Grid container spacing={1}>
                        <Grid item md={4}>
                            <TextField
                                id='description'
                                label='Description'
                                value={qec?.description || ''}
                                fullWidth
                                margin="normal"
                                onChange={(e) => {onFieldChange('description', e.target.value)  }}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={4}>
                            <TextField
                                id='part_number'
                                label='Part number'
                                value={qec?.part_number || ''}
                                fullWidth
                                margin="normal"
                                onChange={(e) => { onFieldChange('part_number', e.target.value)}}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={4}>
                            <TextField
                                // required
                                id='serial_number'
                                label='Serial number'
                                value={qec?.serial_number || ''}
                                fullWidth
                                margin="normal"
                                onChange={(e) => { onFieldChange('serial_number', e.target.value) }}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                                // error={error?.serial_number ? true : false}
                                // helperText={error?.serial_number || ''}
                                onFocus={() => setError({ ...error, 'serial_number': '' })}
                            />
                        </Grid>
                        <Grid item md={4}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    // required
                                    margin="normal"
                                    name="date_lsv"
                                    label="Date LSV"
                                    format={fieldDateFormat}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={qec?.date_lsv || null}
                                    onChange={(data, value) => { onFieldChange('date_lsv', data ? moment(data).format(backendDateFormat) : null); setError({ ...error, 'date_lsv': '' }) }}
                                    inputVariant='outlined'
                                    error={error?.date_lsv ? true : false}
                                    helperText={error?.date_lsv || ''}
                                    onFocus={() => setError({ ...error, 'date_lsv': '' })}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={12}>
                            <TextField
                                id='remarks'
                                label='Remarks'
                                value={qec?.remarks || ''}
                                fullWidth
                                margin="normal"
                                onChange={(e) => { onFieldChange('remarks', e.target.value)}}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>

                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                    <Button disabled={isLoading|| !isAnyFieldFilled} onClick={onAddEditSubModule} color='primary' size='small' variant='contained'>
                        {isLoading ? <CircularProgress size={24} /> : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    )
}
function QEC({ params }) {
    const navTitleOffset = usePageTitleOffset('techSpecsNavCollapsed');
    const { enqueueSnackbar, } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [qecList, setQecList] = useState({ list: [], pagination: null });
    const [addEditQEC, setAddEditQec] = useState({ modal: false, data: null });
    const [deleteQEC, setDeleteQec] = useState({ modal: false, data: null });
    const { assetInfoData, assetSkeletonLoader, refreshAssetInfo } = useAssetInfo(params.type, params.aircraft_slug);
    useEffect(() => {
        getQecList({per_page:20}, 'skeletonLoader');
    }, []);
    const getQecList = (query, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`console/v2/${params.type}/${params.aircraft_slug}/qec/`, query)
            .then(response => {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
                if (checkApiStatus(response)) {
                    setQecList(response.data.data)
                }
            })
    }

      const onExportQEC = () => {
            setLoading(true);
            globalExportService(`console/v2/${params.type}/${params.aircraft_slug}/qec/?download=xlsx`)
                .then(response => {
                    downloadFileType(response, `${assetTypeValues[assetInfoData?.asset_type.type].label}-${assetInfoData?.serial_number}_Avionics ${moment().format(fieldDateFormat)}`, 'xlsx')
                    trackActivity('Export', { page_title: 'qec', asset_type: 'MSN', asset_name: assetInfoData?.serial_number, event_type: 'QEC Data Exported', event_desc: ``, file_extension: 'xlsx' })
                    setLoading(false)
                });
        }

    const onDeleteQec = () => {
        setLoading(true);
        globalDeleteService(`console/v2/${params.type}/${params.aircraft_slug}/qec/${deleteQEC.data.id}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    setDeleteQec({ modal: false, data: null })
                    getQecList({per_page:20}, 'pageLoader');
                }
                setLoading(false);
            })
    }
    return (
        <section className="asset-tech-specs">
            <AssetInfo assetInfoData={assetInfoData} skeletonLoader={assetSkeletonLoader} getResponseBack={refreshAssetInfo} />
            <Paper className="tech-specs-card  console-paper" style={{ minHeight: `${window.innerHeight - 162}px` }} >
                <TechSpecsNav />
                <div className="tech-specs-content">
                    {isLoading ? <PageLoader /> : null}
                    {skeletonLoader ? <STableLoader count={8} /> :
                        <div style={{ padding: '10px' }}>
                             <Paper elevation={0} className="console-paper" style={{ padding: '4px 8px' }}>
                                <ul className="list-inline" style={{ textAlign: "right", marginBottom: '5px' }}>
                                    {qecList?.list?.length ?
                                        <li className="list-inline-item">
                                            <Button  color='primary' variant='outlined' size='small' onClick={onExportQEC} >Export</Button>
                                        </li> : null
                                    }
                                    <li className="list-inline-item">
                                        <Button onClick={() => setAddEditQec({ modal: true, data: {} })} color='primary' size='small' variant='contained'><AddIcon style={{ fontSize: '1.15rem' }} />Add</Button>
                                    </li>
                                </ul>
                             </Paper>
                                <Paper square>
                                    <div style={{ height: !qecList?.list?.length ? `${(window.innerHeight - 240) - navTitleOffset}px` : `${(window.innerHeight - 290) - navTitleOffset}px`, overflow:'auto',marginTop: "4px"  }}>
                                    <Table className='mui-table-format' stickyHeader>
                                        <QECHD />
                                        <TableBody>
                                            {qecList?.list?.length ?
                                                qecList?.list?.map(item =>
                                                    <QECListing
                                                        onEdit={() => setAddEditQec({ data: item, modal: true })}
                                                        onDelete={() => setDeleteQec({ data: item, modal: true })}
                                                        item={item}
                                                        assetInfoData={assetInfoData}
                                                    />) : null
                                            }
                                        </TableBody>
                                    </Table>
                                     {!qecList?.list?.length && !isLoading ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                                    </div>
                                </Paper>
                            {qecList?.pagination ?
                                <Paper square>
                                    <Pagination
                                        pagination={qecList.pagination}
                                        onChangePage={(event, newPage) => getQecList({ page: newPage + 1, per_page: qecList.pagination.per_page }, 'pageLoader')}
                                        onChangeRowsPerPage={(event) => getQecList({ page: 1, per_page: event.target.value }, 'pageLoader')}
                                    />
                                </Paper>
                                : null}
                        </div>}
                </div>
                {addEditQEC?.modal ?
                    <AddQEC
                        params={params}
                        addEditQEC={addEditQEC}
                        toggleModalFn={() => setAddEditQec({})}
                        getResponseBack={() => { setAddEditQec({}); getQecList({per_page:20}) }}
                        getListApi={getQecList}
                    /> : null
                }
                {deleteQEC?.modal ?
                    <DeletePopUp
                        modal={deleteQEC.modal}
                        title='Delete QEC Data'
                        content={`Are you sure, you want to Delete?`}
                        toggleModalFn={() => setDeleteQec({ modal: false, data: null })}
                        deleteRecordFn={onDeleteQec}
                    /> : null
                }
            </Paper>
        </section>

    )
}
export default withRouter(QEC)